var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229.966,
    height: 44.233,
    viewBox: "0 0 229.966 44.233",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(-156.999 -38.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(1434.734 -1659.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(-1277.735 1702.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M-1275.255,1706.846a8.174,8.174,0,0,1,6-2.48,8.15,8.15,0,0,1,5.977,2.48,8.176,8.176,0,0,1,2.48,6v26.1h-6.779v-6.78h-3.378v6.78h-6.779v-26.1A8.174,8.174,0,0,1-1275.255,1706.846Zm7.677,18.544v-12.544a1.638,1.638,0,0,0-.5-1.2,1.612,1.612,0,0,0-1.181-.5,1.64,1.64,0,0,0-1.2.5,1.638,1.638,0,0,0-.5,1.2v12.544Z",
    transform: "translate(1277.735 -1704.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M-1230.38,1705.426v26.1a8.188,8.188,0,0,1-2.457,5.977,8.177,8.177,0,0,1-6,2.481,8.146,8.146,0,0,1-5.976-2.481,8.145,8.145,0,0,1-2.48-5.977v-26.1h6.78v26.1a1.612,1.612,0,0,0,.5,1.181,1.612,1.612,0,0,0,1.181.5,1.641,1.641,0,0,0,1.205-.5,1.613,1.613,0,0,0,.5-1.181v-26.1Z",
    transform: "translate(1268.333 -1704.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M-1200.93,1712.205h-5.126v27.072h-6.756v-27.072h-5.032v-6.779h16.914Z",
    transform: "translate(1259.237 -1704.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M-1172.608,1731.236a8.148,8.148,0,0,1-2.5,5.953,8.107,8.107,0,0,1-5.953,2.456,8.156,8.156,0,0,1-5.953-2.456,8.044,8.044,0,0,1-2.5-5.906v-18.5a8.072,8.072,0,0,1,2.5-5.93,8.159,8.159,0,0,1,5.953-2.457,8.111,8.111,0,0,1,5.953,2.457,8.151,8.151,0,0,1,2.5,5.953Zm-6.756-18.379a1.778,1.778,0,0,0-.5-1.2,1.64,1.64,0,0,0-1.2-.5,1.638,1.638,0,0,0-1.2.5,1.638,1.638,0,0,0-.5,1.2v18.331a1.638,1.638,0,0,0,.5,1.2,1.638,1.638,0,0,0,1.2.5,1.64,1.64,0,0,0,1.2-.5,1.638,1.638,0,0,0,.5-1.2Z",
    transform: "translate(1250.489 -1704.377)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-1194.291 1698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M-1021.863,1714.176a1.64,1.64,0,0,0-1.2.5,1.64,1.64,0,0,0-.5,1.2v12.544h3.378v-12.544a1.638,1.638,0,0,0-.5-1.2A1.611,1.611,0,0,0-1021.863,1714.176Z",
    transform: "translate(1115.786 -1702.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M-1081.573,1715.235h-1.677v10.158h1.677a1.774,1.774,0,0,0,1.2-.5,1.643,1.643,0,0,0,.5-1.2v-6.78a1.616,1.616,0,0,0-.5-1.181A1.643,1.643,0,0,0-1081.573,1715.235Z",
    transform: "translate(1134.221 -1703.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M-961.287,1715.2h-1.7v20.316h1.7a1.616,1.616,0,0,0,1.181-.5,1.642,1.642,0,0,0,.5-1.2v-16.938a1.614,1.614,0,0,0-.5-1.181A1.613,1.613,0,0,0-961.287,1715.2Z",
    transform: "translate(1097.077 -1703.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M-1157,1698v44.233h146.521V1698Zm15.956,38.984h-7.866l-6.52-33.851h6.779l3.874,22.3,2.953-22.3h7.37Zm24.394-27.1h-8.126v10.158h6.78v6.78h-6.78v3.4h8.126v6.779h-14.906v-33.9h14.906Zm15.157,27.1-1.157-8.15-.023-.307a2,2,0,0,0-.686-1.2,1.857,1.857,0,0,0-1.252-.5h-1.417v10.158h-6.78v-33.851h8.5a8.244,8.244,0,0,1,5.953,2.48,8.107,8.107,0,0,1,2.457,5.953v6.827a8.125,8.125,0,0,1-2.056,5.5,9.268,9.268,0,0,1,2.032,4.583l.024.189,1.158,8.315Zm26.52-22.631h-6.757v-3.472a1.612,1.612,0,0,0-.5-1.181,1.637,1.637,0,0,0-1.2-.5,1.6,1.6,0,0,0-1.063.378.417.417,0,0,0-.118.118h-.023a.729.729,0,0,0-.095.118h-.023a1.028,1.028,0,0,0-.071.118v.024h-.024a1.135,1.135,0,0,0-.071.118c.015-.016.015-.008,0,.023a1.18,1.18,0,0,0-.071.118l-.023.07-.024.095-.023.095-.024.071a.4.4,0,0,1-.023.095v7.725a1.642,1.642,0,0,0,.5,1.2,1.653,1.653,0,0,0,1.181.472l.308.024a8.191,8.191,0,0,1,5.788,2.575,8.191,8.191,0,0,1,2.362,5.882,8.186,8.186,0,0,1-2.457,5.976,8.174,8.174,0,0,1-6,2.48h-8.457V1730.2h8.457a1.64,1.64,0,0,0,1.2-.5,1.612,1.612,0,0,0,.5-1.181,1.637,1.637,0,0,0-.5-1.2,1.637,1.637,0,0,0-1.2-.5h-.33a8.206,8.206,0,0,1-5.741-2.575,8.242,8.242,0,0,1-2.386-5.858v-7.536a8.188,8.188,0,0,1,2.48-5.953,8.194,8.194,0,0,1,5.953-2.48h.331a8.194,8.194,0,0,1,5.788,2.575,8.19,8.19,0,0,1,2.362,5.882Zm20.354,22.631h-6.78V1730.2h-3.378v6.779h-6.78v-26.1a8.174,8.174,0,0,1,2.48-6,8.174,8.174,0,0,1,6-2.48,8.148,8.148,0,0,1,5.977,2.48,8.176,8.176,0,0,1,2.48,6Zm21.063-.024h-6.756v-11.93l-3.4-7.937v19.867h-6.756v-33.828h6.756v.165l3.4,7.937v-8.1h6.756Zm20.8-8.41a8.191,8.191,0,0,1-2.48,5.953,8.185,8.185,0,0,1-5.953,2.48h-8.5v-33.875h8.5a8.193,8.193,0,0,1,5.953,2.48,8.2,8.2,0,0,1,2.48,5.953Z",
    transform: "translate(1157 -1698)",
    fill: "#fff"
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.4259d1b9.svg";
export { ForwardRef as ReactComponent };